import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServiceCategoriesEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

class ServiceCategoriesEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private sc_Input_Description_MultiLang: MdsLax<InstanceType<typeof MultiLangEdit<any>>>;

    isValid(): boolean {
        let isValid = true;

        isValid = isValid && this.sc_Input_Description_MultiLang.isValid;

        return isValid;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.ServiceCategory;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ServiceCategoriesEditorV2);
